import React from 'react';
import { AccordionStoryblok } from '../../../_shared/interfaces/storyblok';
import { isRichText } from '../../../lib/helpers/helpers';
import { getRichTextMarkup, StoryblokCommon } from '../../../lib/storyblok/storyblok';

import * as RichtextStyles from '../../../_scss/modules/_richtext.module.scss';
import * as AccordionGenericStylesHs from './accordion.module.scss';
import * as AccordionStylesHs from './accordion.hs.module.scss';
import * as AccordionStylesDr from './accordion.dr.module.scss';
import { trackEvent } from '../../../lib/track/track';

const Accordion = ({ blok, storyblokCommon }: { blok: AccordionStoryblok; storyblokCommon: StoryblokCommon }) => {
    const AccordionStyles = storyblokCommon.configuration.content.theme === 'dr' ? AccordionStylesDr : AccordionStylesHs;
    const [activeIndexes, setActiveIndexes] = React.useState<number[]>([]);

    const toggle = (index: number, headline: string | undefined, opened: boolean): void => {
        let newActiveIndexes = activeIndexes.slice(0);

        if (activeIndexes.indexOf(index) !== -1) {
            newActiveIndexes = newActiveIndexes.filter((entry) => entry !== index);
        } else {
            newActiveIndexes.push(index);
        }
        setActiveIndexes(newActiveIndexes);
        if (!opened && headline) {
            trackEvent('accordion.open', { accordion: { name: headline } });
        }
    };

    return (
        <div
            className={[AccordionGenericStylesHs.accordionGeneric, AccordionStyles.accordion].join(' ')}
            style={{ padding: blok.padding ? '0 80px' : undefined }}
        >
            {blok.headline && blok.headline_size === 'large' && <h4>{blok.headline}</h4>}
            {blok.headline && blok.headline_size === 'small' && <h5>{blok.headline}</h5>}
            {isRichText(blok.copytext) && (
                <div className={AccordionGenericStylesHs.copytext} dangerouslySetInnerHTML={getRichTextMarkup(blok.copytext)} />
            )}
            <ul className={blok.entries_headline_size === 'small' ? AccordionStyles.headlineSizeSmall : ''}>
                {blok.entries.map((entry, index) => {
                    return (
                        <li key={entry._uid} className={activeIndexes.includes(index) ? AccordionGenericStylesHs.opened : ''}>
                            <button onClick={() => toggle(index, entry.headline, activeIndexes.includes(index))}>{entry.headline}</button>
                            <div className={[AccordionGenericStylesHs.content, AccordionStyles.content].join(' ')}>
                                <div dangerouslySetInnerHTML={getRichTextMarkup(entry.content)} className={RichtextStyles.richtext} />
                            </div>
                        </li>
                    );
                })}
            </ul>
        </div>
    );
};

export default Accordion;
